import { useEffect, useState } from 'react';
import {
  MOBILE_BREAKPOINT,
  TOUCH_TABLET_MEDIA_QUERY,
  readIsTablet,
} from './deviceLayout';

let isMobileCache = window.innerWidth < MOBILE_BREAKPOINT;
let isTabletCache = readIsTablet();
let windowHeightCache = window.innerHeight;
const subscribers = new Set();
let listenerAttached = false;
let tabletMql = null;

const notifySubscribers = () => {
  subscribers.forEach((callback) => callback());
};

const handleResize = () => {
  const nextMobile = window.innerWidth < MOBILE_BREAKPOINT;
  const nextTablet = readIsTablet();
  const nextHeight = window.innerHeight;
  if (
    nextMobile === isMobileCache &&
    nextTablet === isTabletCache &&
    nextHeight === windowHeightCache
  ) {
    return;
  }
  isMobileCache = nextMobile;
  isTabletCache = nextTablet;
  windowHeightCache = nextHeight;
  notifySubscribers();
};

const subscribe = (callback) => {
  subscribers.add(callback);
  if (!listenerAttached) {
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    tabletMql = window.matchMedia(TOUCH_TABLET_MEDIA_QUERY);
    if (tabletMql.addEventListener) {
      tabletMql.addEventListener('change', handleResize);
    } else {
      tabletMql.addListener(handleResize);
    }
    listenerAttached = true;
  }
  return () => {
    subscribers.delete(callback);
    if (subscribers.size === 0 && listenerAttached) {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      if (tabletMql?.removeEventListener) {
        tabletMql.removeEventListener('change', handleResize);
      } else if (tabletMql?.removeListener) {
        tabletMql.removeListener(handleResize);
      }
      tabletMql = null;
      listenerAttached = false;
    }
  };
};

function useWindowSize() {
  const [isMobile, setIsMobile] = useState(isMobileCache);
  const [isTablet, setIsTablet] = useState(isTabletCache);
  const [windowHeight, setWindowHeight] = useState(windowHeightCache);

  useEffect(() => {
    const onUpdate = () => {
      setIsMobile(isMobileCache);
      setIsTablet(isTabletCache);
      setWindowHeight(windowHeightCache);
    };

    onUpdate();
    return subscribe(onUpdate);
  }, []);

  return { isMobile, isTablet, isTabletPortrait: isTablet, windowHeight };
}

export default useWindowSize;
